export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  // Content-Type only when a JSON body exists — Fastify 400s on an empty JSON
  // body, and FormData must set its own multipart boundary.
  const isJsonBody = init?.body != null && !(init.body instanceof FormData);
  const res = await fetch(path, {
    headers: { ...(isJsonBody ? { 'Content-Type': 'application/json' } : {}), ...init?.headers },
    credentials: 'same-origin',
    ...init,
  });
  if (res.status === 401) {
    window.location.href = '/auth/login';
    throw new ApiError(401, 'Not authenticated');
  }
  if (!res.ok) {
    const body = await res.text();
    throw new ApiError(res.status, body || res.statusText);
  }
  return (await res.json()) as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body) }),
  /** multipart/form-data POST (file uploads). */
  upload: <T>(path: string, form: FormData) => request<T>(path, { method: 'POST', body: form }),
};
